import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { useGetUser } from './context/userContext';

import './App.css';
import Footer from './components/Footer/Footer';
import Navbar from './components/Navbar/Navbar';
import Home from './pages/Home';
import Profile from './pages/Profile';
import Login from './pages/Login';
import Register from './pages/Register';

function App() {
  const user = useGetUser();
  return (
    <Switch>
      <Route path="/" exact>
        <Navbar />
        <Home />
        <Footer />
      </Route>

      <Route path="/login" exact>
        {user === 'loading' ? null : (
          <>
            <Navbar />
            {user ? <Redirect to="/profile" /> : <Login />}
            <Footer />
          </>
        )}
      </Route>

      <Route path="/register" exact>
        {user === 'loading' ? null : (
          <>
            <Navbar />
            {user ? <Redirect to="/profile" /> : <Register />}
            <Footer />
          </>
        )}
      </Route>

      <Route path="/profile" exact>
        <Navbar />
        {!user ? <Redirect to="/login" /> : <Profile />}
        <Footer />
      </Route>

      <Route path="/">
        <div>TODO: Error Page</div>
      </Route>
    </Switch>
  );
}

export default App;
